import Vue from "vue";
import {numberFormat} from "@/helpers/util.js";
const vm = new Vue()
import { helpers } from 'vuelidate/lib/validators'
import popStorage from '@/constants/LocalStorageManagement'
export const walletPayment = async () => {
  return new Promise((resolve, reject) => {
    vm.$http.get( vm.$API_URL + "/wallet/account/wallet/info" , {
        headers: {
            Token: localStorage.getItem("access_token")
        }
        }).then( res => {
          popStorage.wallet().set({
            status: res.data.status,
            available_balance: res.data.data.available_balance,
            balance: res.data.data.balance,
            peg_balance: res.data.data.peg_balance
          })
          resolve(res.data.data)
        })
  })
}

export const checkWithDrawAmount = (value) => !helpers.req(value) || !( value < 100 )

export const statusPayment = (status, subject = null) => {
  switch ( String(status) ) {
      case '0':
          return { status: `รออนุมัติ` , color: `warning`, icon: `far fa-clock` }
      case '1':
          return {
            status: subject == 'cancel-pend-withdraw' ? `คืนเงิน` : `สำเร็จ`,
            color: subject == 'cancel-pend-withdraw' ? `primary` : `success`,
            icon: subject == 'cancel-pend-withdraw' ? `fas fa-long-arrow-alt-right`: `far fa-check-circle`
          } 
      case '2':
          return { status: `ยกเลิกสำเร็จ` , color: `success`, icon: `far fa-check-circle` } 
      default:
          return { status: `ไม่มีสถานะ` , color: `dark`, icon: `fas fa-question` }
  }
};

export const statusPaymentSubject = subject => {
  const isSuperadmin = vm.$USER_LOGIN.get().isSuperadmin
  switch ( String(subject) ) {
      case 'pend-deposit':
      case 'deposit':
          return { text: isSuperadmin ? `ค่าขนส่ง` : `เติมเครดิต` , color: `success`}
      case 'cancel-pend-deposit':
          return { text: isSuperadmin ? `ยกเลิกรายการขนส่ง` : `ยกเลิกรายการเติมเครดิต` , color: `warning`}
      case 'pend-withdraw':
      case 'withdraw':
          return { text: `ค่าขนส่ง` , color: `warning`} 
      case 'cancel-pend-withdraw':
          return { text: `ยกเลิกรายการขนส่ง` , color: `warning`} 
      default:
          return { text: `ไม่มีสถานะ` , color: `dark`}
  }
};

export const statusPaymentChannel = subject => {
  switch ( String(subject) ) {
      case 'DEPOSIT_PGW':
          return { text: `เติมเงินโดยร้านค้า` , color: `warning`}
      case 'DEPOSIT_INSTANT':
          return { text: `เติมเงินโดย SuperAdmin` , color: `success`} 
      default:
          return { text: `ไม่มีสถานะ` , color: `dark`}
  }
};

export const checkStatusPending = str => {
  return /^(pend).*/.test(str)
};

export const rowClass = (item, type) => {
  if (!item || type !== 'row') return
  if (!checkStatusPending(item.subject)) return
  return 'text-muted'
};
export const rowClassTransaction = (item) => {
  let res = {text: '', fontColor: ''}
  const credit = ' ฿'+numberFormat(item.credit)
  if (item.subject === 'pend-deposit') {
    res.text = '+' + credit
  }else if(item.subject === 'deposit'){
    res.text = '+' + credit
    res.fontColor = 'text-success'
  }else if(item.subject === 'pend-withdraw'){
    res.text = '-' + credit
  }else if(item.subject === 'withdraw'){
    res.text = '-' + credit
    res.fontColor = 'text-danger'
  }else if(item.subject === 'cancel-pend-withdraw'){
    res.text = '+' + credit
    res.fontColor = 'text-primary'
  }
  return res
};
export const checkStatusRefNo2 = status => {
 if( status === 'DEPOSIT_PGW') return 'เติมผ่านระบบ'
 if( status === 'DEPOSIT_INSTANT') return 'เติมผ่านผู้ดูแล'
 return status
};

export const convertDataWallet = data => {
  if (data.length < 1) return data
  data.forEach( val => {
    val.status = statusPayment(val.status, val.subject).status
    val.subject = statusPaymentSubject(val.subject).text
    val.ref_no2 = checkStatusRefNo2(val.ref_no2)
  })
  return data
};